import axios from 'axios';
import config from "./config";

let  instance = axios.create({
    baseURL: config().accountUrl
});

export default instance;